import { render, staticRenderFns } from "./LmDocumentsNewOrEdit.vue?vue&type=template&id=4d896784&scoped=true"
import script from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentsNewOrEdit.vue?vue&type=style&index=0&id=4d896784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d896784",
  null
  
)

export default component.exports